import React from "react";
import { Icon } from "@chakra-ui/react";

export const FilterIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25C21 5.66421 20.6642 6 20.25 6H3.75C3.33579 6 3 5.66421 3 5.25Z"
        fill="currentColor"
      />
      <path
        d="M6 11.25C6 10.8358 6.33579 10.5 6.75 10.5H17.25C17.6642 10.5 18 10.8358 18 11.25C18 11.6642 17.6642 12 17.25 12H6.75C6.33579 12 6 11.6642 6 11.25Z"
        fill="currentColor"
      />
      <path
        d="M9.75 16.5C9.33579 16.5 9 16.8358 9 17.25C9 17.6642 9.33579 18 9.75 18H14.25C14.6642 18 15 17.6642 15 17.25C15 16.8358 14.6642 16.5 14.25 16.5H9.75Z"
        fill="currentColor"
      />
    </Icon>
  );
};
